import AutoSizedTextArea from 'components/inputs/AutoSizedTextArea';
import LabelWrap from 'components/inputs/LabelWrap';
import Select from 'components/inputs/Select';
import Modal, { modalContentClass } from 'components/Modal';
import { FC, useState } from 'react';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .${modalContentClass} {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 350px;

    select,
    textarea {
      width: auto;
    }
  }
`;

const ON_HOLD_REASONS = [
  'Åter efterkontroll',
  'Ej klar för leverans',
  'På åtgärd',
  'Avvakta',
  'Övrigt',
] as const;

interface OnHoldReasonModalProps {
  onConfirm(reason: string): void;
  onClose(): void;
}

const OnHoldReasonModal: FC<OnHoldReasonModalProps> = ({
  onConfirm,
  onClose,
}) => {
  const [reason, setReason] = useState('');
  const [freeText, setFreeText] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    if (!reason) {
      setError('Ange en anledning');
      return;
    }
    if (reason === 'Övrigt' && !freeText.trim()) {
      setError('Ange en beskrivning');
      return;
    }

    const message =
      reason === 'Övrigt'
        ? `Parkerat: Övrigt - ${freeText}`
        : `Parkerat: ${reason}`;
    onConfirm(message);
  };

  return (
    <StyledModal
      buttons={[
        {
          label: 'Parkera',
          onClick: handleConfirm,
        },
        {
          label: 'Avbryt',
          onClick: onClose,
        },
      ]}
      onClose={onClose}
      title="Parkera uppdrag"
    >
      <LabelWrap
        label="Anledning"
        errorLabel={!reason && error ? error : undefined}
      >
        <Select
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            setError('');
          }}
        >
          <option value="">Välj anledning...</option>
          {ON_HOLD_REASONS.map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </Select>
      </LabelWrap>

      {reason === 'Övrigt' && (
        <LabelWrap
          label="Beskrivning"
          errorLabel={reason === 'Övrigt' && !freeText.trim() && error ? error : undefined}
        >
          <AutoSizedTextArea
            value={freeText}
            onChange={(e) => {
              setFreeText((e.target as HTMLTextAreaElement).value);
              setError('');
            }}
            placeholder="Ange anledning..."
          />
        </LabelWrap>
      )}
    </StyledModal>
  );
};

export default OnHoldReasonModal;
